import Seo from "../components/Seo";

export default function Offline() {
  return (
    <>
      <Seo title="You're Offline" description="You appear to be offline." />
      <h1>You&rsquo;re offline</h1>
      <p>
        It looks like you&rsquo;ve lost your internet connection. You can still browse pages you&rsquo;ve
        already visited, but RSVPs and live event data require a connection.
      </p>
      <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
        Try again
      </button>
    </>
  );
}
